const PaymentChannel = require('@/lib/Channels/PaymentChannel');
const PaymentChannelIDEnum = require('@/lib/Channels/PaymentChannelIDEnum');

/**
 * Creates the payment channel for orders made in ProPoint.
 *
 * @return {PaymentChannel}
 */
const getDefaultPaymentChannel = () => {
    return PaymentChannel.fromID(PaymentChannelIDEnum.EPOS);
};

module.exports = {
    getDefaultPaymentChannel,
};
